import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EmailList from './List';
import EmailDetails from './Details';

export default function Email() {
  return (
    <div>
      <Routes>
        <Route path="" element={<EmailList />} />
        <Route path=":id" element={<EmailDetailsRouter />} />
      </Routes>
    </div>
  );
}

function EmailDetailsRouter() {
  const { useParams } = require('react-router-dom');
  const params = useParams();
  return <EmailDetails id={params.id} />;
}
